"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
export default function Ready() {
  const {
    ref: word1Ref,
    isVisible: word1Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word2Ref,
    isVisible: word2Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: word3Ref,
    isVisible: word3Visible
  } = useRevealOnScroll<HTMLSpanElement>({
    threshold: 0.2
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="3501" id="ready-to-print-your-vision" className="dark text-foreground relative overflow-hidden py-24 px-6 !bg-[rgba(0,33,165,1)] md:py-40 lg:py-[200px] md:px-12 lg:px-20">
      {}
      <div className="hidden md:block absolute left-6 top-1/2 -translate-y-1/2 z-10">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] block" style={{
        color: "var(--primary)",
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
          CTA — INITIATE
        </span>
      </div>

      {}
      <div className="hidden md:block absolute right-0 top-0 bottom-0 w-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 8px var(--primary)"
    }} aria-hidden="true" />

      {}
      <div className="md:hidden absolute left-0 right-0 top-0 h-[2px] z-10" style={{
      background: "var(--primary)",
      boxShadow: "0 0 40px 4px var(--primary)"
    }} aria-hidden="true" />

      <div className="relative max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          {}
          <div className="lg:col-span-7 lg:col-start-1">
            <h2 className="font-default font-extrabold uppercase leading-[0.9] text-foreground text-[56px] sm:text-[80px] md:text-[110px] lg:text-[140px]" style={{
            letterSpacing: "-0.04em"
          }}>
              <span ref={word1Ref} data-index={0} className="block transition-all duration-700 ease-out" style={{
              opacity: word1Visible ? 1 : 0,
              transform: word1Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "0ms"
            }}>READY&nbsp;</span>
              <span ref={word2Ref} data-index={1} className="block transition-all duration-700 ease-out" style={{
              opacity: word2Visible ? 1 : 0,
              transform: word2Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "200ms"
            }}>TO PRINT </span>
              <span ref={word3Ref} data-index={2} className="block transition-all duration-700 ease-out" style={{
              opacity: word3Visible ? 1 : 0,
              transform: word3Visible ? "translateY(0)" : "translateY(40px)",
              transitionDelay: "400ms"
            }}>
                YOUR VISION
                <span className="inline-block align-baseline !text-[rgba(0,33,165,1)]" style={{
                color: "var(--primary)",
                fontSize: "1.3em",
                lineHeight: 0
              }}>
                  .
                </span>
              </span>
            </h2>
          </div>

          {}
          <div className="lg:col-span-5 lg:col-start-8 flex lg:justify-end">
            <div ref={cardRef} className="w-full lg:max-w-[440px] p-8 md:p-10 border border-foreground/10 backdrop-blur-sm transition-all duration-700 ease-out shadow-lg rounded-lg" style={{
            backgroundColor: "var(--card)",
            opacity: cardVisible ? 1 : 0,
            transform: cardVisible ? "translateX(0)" : "translateX(40px)",
            transitionDelay: "600ms"
          }}>
              {}
              <div className="font-mono text-[11px] uppercase tracking-[0.2em] mb-6 !text-[rgba(250,70,22,1)]" style={{
              color: "var(--primary)"
            }}>
                START YOUR RUN
              </div>

              {}
              <p className="font-default font-light text-base md:text-lg leading-relaxed text-foreground/90 mb-8">
                Transform your digital designs into high-quality apparel prints. Our precision heat-press technology ensures vibrant, durable results for every project.
              </p>

              {}
              <Button asChild className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive text-primary-foreground px-4 py-2 has-[>svg]:px-3 w-full h-14 uppercase font-default font-bold text-sm tracking-[0.15em] shadow-md transition-opacity rounded-lg !bg-[rgba(250,70,22,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:opacity-90" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                <Link to="#">
                  INITIALIZE ORDER
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>

              {}
              <div className="mt-5 font-mono text-[11px] uppercase tracking-[0.18em]" style={{
              color: "var(--muted-foreground)"
            }}>
                FAST TURNAROUND — GLOBAL SHIPPING
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}